import { inject, Injectable } from '@angular/core';
import { HttpResourceRequest } from '@angular/common/http';

import { endpoints } from '../../../../environments/endpoints';
import { ApiService } from '../../Shared/Services/api.service';
import { DemandReferenceResolveResponse } from '../../../Interfaces/api/catalog/demand-reference.interface';

@Injectable({ providedIn: 'root' })
export class DemandReferenceService {
  private readonly _api = inject(ApiService);

  resolve(reference: string): HttpResourceRequest {
    return this._api.get<DemandReferenceResolveResponse>(
      endpoints.api.catalog.demands.resolve(reference),
      { skipLoading: true, skipError: true },
    );
  }
}
